export default __webpack_public_path__ + "static/collectupiflow-5ffd6a1b64567e2dd896de256ab33001.webp";